import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, renderList as _renderList, vModelText as _vModelText, vModelRadio as _vModelRadio, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48cde224")

_pushScopeId("data-v-48cde224")
const _hoisted_1 = { class: "social-post-page" }
const _hoisted_2 = { class: "social-post-page__content" }
const _hoisted_3 = { class: "social-post-page__header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left me-1" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_6 = { class: "social-post-page__title mb-0" }
const _hoisted_7 = { class: "social-post-page__header-actions" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-warning mb-4"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin me-2" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Preparing media uploads… Your post will be ready shortly. ")
const _hoisted_11 = {
  key: 1,
  class: "alert alert-info mb-4"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin me-2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Reel generating… Voice → Video (~30s). You can edit the caption. ")
const _hoisted_14 = {
  key: 2,
  class: "alert alert-warning mb-4"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Connect your AI 24/7 first before publishing content. ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Complete setup in the ")
const _hoisted_17 = /*#__PURE__*/_createVNode("strong", null, "Portal", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" tab.")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Go to AI 24/7")
const _hoisted_20 = {
  key: 3,
  class: "alert alert-info mb-4"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Connect at least one social account in the ")
const _hoisted_22 = /*#__PURE__*/_createVNode("strong", null, "Social Fan-out", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" tab")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Social Fan-out")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" settings before publishing. ")
const _hoisted_26 = { class: "row g-4" }
const _hoisted_27 = { class: "col-lg-7" }
const _hoisted_28 = { class: "social-post-page__composer card border-0" }
const _hoisted_29 = { class: "card-body p-4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label" }, "Post to", -1)
const _hoisted_31 = { class: "d-inline-flex align-items-center gap-2" }
const _hoisted_32 = { class: "text-muted fs-8" }
const _hoisted_33 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label" }, "Type content", -1)
const _hoisted_34 = { class: "social-post-page__editor" }
const _hoisted_35 = { class: "social-post-page__toolbar" }
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pen-fancy" }, null, -1)
const _hoisted_37 = { class: "d-flex flex-column gap-2" }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "fas fa-magic" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("i", { class: "far fa-image" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "social-post-page__tool-btn",
  title: "Add image or video URL"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-link" })
], -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Media URLs", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8" }, "External image and video URLs supported.", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "social-post-page__tool-btn",
  title: "Add link"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-external-link-alt" })
], -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Link URL", -1)
const _hoisted_45 = { class: "social-post-page__follow-up mt-4" }
const _hoisted_46 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_47 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-0" }, "Follow up comment", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "fs-8" }, [
  /*#__PURE__*/_createVNode("strong", null, "Available for"),
  /*#__PURE__*/_createVNode("ul", { class: "mb-0 ps-3 mt-1" }, [
    /*#__PURE__*/_createVNode("li", null, "Facebook Pages"),
    /*#__PURE__*/_createVNode("li", null, "Instagram Business Account"),
    /*#__PURE__*/_createVNode("li", null, "LinkedIn Profiles and Pages")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "mt-2 text-muted" }, "Not supported for Google Business Profile or TikTok.")
], -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "social-post-page__info-btn",
  "aria-label": "Follow up comment help"
}, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-question-circle" })
], -1)
const _hoisted_50 = { class: "text-muted fs-8 mt-1" }
const _hoisted_51 = {
  key: 0,
  class: "social-post-page__facebook-options mt-4"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("span", null, "Facebook options", -1)
const _hoisted_53 = { class: "social-post-page__facebook-panel mt-3" }
const _hoisted_54 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Post this as", -1)
const _hoisted_55 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_56 = { class: "text-muted fs-8 mt-2" }
const _hoisted_57 = {
  key: 1,
  class: "social-post-page__reel-panel mt-4"
}
const _hoisted_58 = { class: "social-post-page__reel-panel-toggle-content" }
const _hoisted_59 = { class: "d-flex flex-wrap align-items-center gap-2 mb-1" }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Faceless Reel", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "badge badge-light-primary social-post-page__reel-badge" }, "Auto-generate", -1)
const _hoisted_62 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8" }, " Create a new AI video here. To use your own reel instead, upload or attach a video above. ", -1)
const _hoisted_64 = { class: "social-post-page__reel-panel-body" }
const _hoisted_65 = { class: "text-muted fs-8 mb-3" }
const _hoisted_66 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Reel type", -1)
const _hoisted_67 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_68 = {
  key: 0,
  class: "text-muted fs-8 ms-1"
}
const _hoisted_69 = { class: "text-muted fs-8 mb-3" }
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "If your clip is shorter than the voiceover", -1)
const _hoisted_71 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_72 = { class: "social-post-page__radio-option" }
const _hoisted_73 = /*#__PURE__*/_createVNode("span", null, "Hold last frame", -1)
const _hoisted_74 = { class: "social-post-page__radio-option" }
const _hoisted_75 = /*#__PURE__*/_createVNode("span", null, "Loop the clip", -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8 mb-3" }, " Hold keeps the last frame on screen. Loop repeats your clip until the voiceover ends. ", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-2" }, " Product (required) ", -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Voice", -1)
const _hoisted_79 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Tone", -1)
const _hoisted_81 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_82 = { class: "social-post-page__reel-tones mb-3" }
const _hoisted_83 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-2" }, " Tone changes how the AI speaks your script — pace and energy. Use Preview to hear it with your selected voice. ", -1)
const _hoisted_84 = { class: "social-post-page__reel-tone-body" }
const _hoisted_85 = { class: "social-post-page__reel-tone-title" }
const _hoisted_86 = {
  key: 0,
  class: "social-post-page__reel-tone-description"
}
const _hoisted_87 = {
  key: 1,
  class: "social-post-page__reel-tone-best-for"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Background music", -1)
const _hoisted_89 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_90 = { class: "social-post-page__reel-tones mb-3" }
const _hoisted_91 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-2" }, " Instrumental tracks work best. Music plays under your voiceover. Use Preview to hear a short clip. ", -1)
const _hoisted_92 = { class: "social-post-page__reel-tone-option" }
const _hoisted_93 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__reel-tone-body" }, [
  /*#__PURE__*/_createVNode("span", { class: "social-post-page__reel-tone-title" }, "No music")
], -1)
const _hoisted_94 = { class: "social-post-page__reel-tone-body" }
const _hoisted_95 = { class: "social-post-page__reel-tone-title" }
const _hoisted_96 = {
  key: 0,
  class: "text-muted fw-normal"
}
const _hoisted_97 = {
  key: 0,
  class: "social-post-page__reel-tone-description"
}
const _hoisted_98 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__label mb-0" }, "Caption look", -1)
const _hoisted_99 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_100 = { class: "social-post-page__caption-style mb-3" }
const _hoisted_101 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-2" }, " Choose how on-screen captions appear in your reel. Timing follows your voiceover. ", -1)
const _hoisted_102 = { class: "social-post-page__caption-preview-stage mb-3" }
const _hoisted_103 = { class: "social-post-page__caption-swatches mb-3" }
const _hoisted_104 = /*#__PURE__*/_createVNode("span", null, "Aa", -1)
const _hoisted_105 = { class: "social-post-page__caption-swatch-label" }
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Size", -1)
const _hoisted_107 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_108 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Position", -1)
const _hoisted_109 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_110 = /*#__PURE__*/_createVNode("div", { class: "social-post-page__label mb-2" }, "Casing", -1)
const _hoisted_111 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_112 = { class: "social-post-page__label mb-2" }
const _hoisted_113 = /*#__PURE__*/_createTextVNode(" Brief")
const _hoisted_114 = { key: 0 }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { class: "text-muted fs-8 mb-3" }
const _hoisted_117 = /*#__PURE__*/_createVNode("label", { class: "social-post-page__label mb-2" }, "Reel script", -1)
const _hoisted_118 = { class: "d-flex flex-wrap gap-2 mb-2" }
const _hoisted_119 = {
  key: 5,
  class: "text-danger fs-8"
}
const _hoisted_120 = {
  key: 6,
  class: "text-muted fs-8 mt-2"
}
const _hoisted_121 = /*#__PURE__*/_createTextVNode(" Music: ")
const _hoisted_122 = { key: 1 }
const _hoisted_123 = /*#__PURE__*/_createTextVNode(" · ")
const _hoisted_124 = {
  key: 2,
  class: "social-post-page__attachments mt-3"
}
const _hoisted_125 = {
  key: 2,
  class: "social-post-page__attachment-video"
}
const _hoisted_126 = /*#__PURE__*/_createVNode("i", { class: "fas fa-video text-white" }, null, -1)
const _hoisted_127 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_128 = /*#__PURE__*/_createVNode("span", { class: "social-post-page__attachment-label" }, "New", -1)
const _hoisted_129 = {
  key: 3,
  class: "social-post-page__cascade mt-4"
}
const _hoisted_130 = { class: "form-check" }
const _hoisted_131 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "cascadeToTeam"
}, " Also post to my team's social accounts ", -1)
const _hoisted_132 = {
  key: 0,
  class: "social-post-page__cascade-notes mt-2"
}
const _hoisted_133 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8" }, [
  /*#__PURE__*/_createTextVNode(" Team members receive a "),
  /*#__PURE__*/_createVNode("strong", null, "feed post linking to your original"),
  /*#__PURE__*/_createTextVNode(". Reels, Stories, Instagram, and TikTok are not sent to the team. ")
], -1)
const _hoisted_134 = { class: "form-check mt-2" }
const _hoisted_135 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "varyCaption"
}, " Use a different caption for each team member ", -1)
const _hoisted_136 = {
  key: 0,
  class: "text-muted fs-8 mt-1"
}
const _hoisted_137 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8 mt-2" }, " Team posts are scheduled after yours, spaced apart. Coordinated engagement farming may result in reduced reach on social platforms. ", -1)
const _hoisted_138 = {
  key: 1,
  class: "text-muted fs-8 mt-1"
}
const _hoisted_139 = { class: "social-post-page__footer" }
const _hoisted_140 = { class: "social-post-page__footer-secondary" }
const _hoisted_141 = {
  ref: "postActionsRef",
  class: "social-post-page__post-actions"
}
const _hoisted_142 = /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane me-2" }, null, -1)
const _hoisted_143 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-down" }, null, -1)
const _hoisted_144 = /*#__PURE__*/_createTextVNode("Post now")
const _hoisted_145 = /*#__PURE__*/_createTextVNode("Schedule post")
const _hoisted_146 = { class: "col-lg-5" }
const _hoisted_147 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Date and time", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_ReelCatalogLibrary = _resolveComponent("ReelCatalogLibrary")
  const _component_ReelVoicePicker = _resolveComponent("ReelVoicePicker")
  const _component_ReelSceneEditor = _resolveComponent("ReelSceneEditor")
  const _component_ContentMediaLibrary = _resolveComponent("ContentMediaLibrary")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_SocialPostPreview = _resolveComponent("SocialPostPreview")
  const _component_SuggestCaptionDialog = _resolveComponent("SuggestCaptionDialog")
  const _component_SuggestPostImageDialog = _resolveComponent("SuggestPostImageDialog")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (!_ctx.embedded)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-sm btn-light social-post-page__back",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewHistory && _ctx.viewHistory(...args)))
            }, [
              _hoisted_4,
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createVNode("h4", _hoisted_6, _toDisplayString(_ctx.pageTitle), 1),
        _createVNode("div", _hoisted_7, [
          (_ctx.showStartNewPostButton)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-light social-post-page__new-post",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.beginNewPost && _ctx.beginNewPost(...args)))
              }, " Start new post "))
            : _createCommentVNode("", true),
          _createVNode("button", {
            type: "button",
            class: "btn btn-sm btn-link social-post-page__history",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.viewHistory && _ctx.viewHistory(...args)))
          }, " View history ")
        ])
      ]),
      (_ctx.campaignStatus === 'preparing')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.facelessReelEnabled && _ctx.reelGenerating)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13
          ]))
        : _createCommentVNode("", true),
      (!_ctx.hasGhlLocation)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _hoisted_15,
            (_ctx.embedded)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18
                ], 64))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/settings/ai247-portal",
                  class: "fw-bold"
                }, {
                  default: _withId(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }))
          ]))
        : (_ctx.connectedAccounts.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _hoisted_21,
              (_ctx.embedded)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_22,
                    _hoisted_23
                  ], 64))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: "/settings/ai247-portal?tab=social",
                    class: "fw-bold"
                  }, {
                    default: _withId(() => [
                      _hoisted_24
                    ]),
                    _: 1
                  })),
              _hoisted_25
            ]))
          : _createCommentVNode("", true),
      _createVNode("div", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_el_select, {
                modelValue: _ctx.selectedAccountKeys,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedAccountKeys = $event)),
                multiple: "",
                filterable: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                placeholder: "Select a social account",
                class: "w-100 mb-4",
                disabled: !_ctx.hasGhlLocation || !_ctx.connectedAccounts.length,
                onChange: _ctx.onAccountsChange
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.connectedAccounts, (account) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: _ctx.accountOptionKey(account),
                      label: _ctx.accountDisplayName(account),
                      value: _ctx.accountOptionKey(account)
                    }, {
                      default: _withId(() => [
                        _createVNode("span", _hoisted_31, [
                          _createVNode("i", {
                            class: _ctx.getPlatformMeta(account.platform).icon,
                            style: { color: _ctx.getPlatformMeta(account.platform).color }
                          }, null, 6),
                          _createVNode("span", null, _toDisplayString(_ctx.accountDisplayName(account)), 1),
                          _createVNode("span", _hoisted_32, "(" + _toDisplayString(_ctx.getPlatformMeta(account.platform).label) + ")", 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "onChange"]),
              _hoisted_33,
              _createVNode("div", _hoisted_34, [
                _withDirectives(_createVNode("textarea", {
                  ref: "captionInput",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.caption = $event)),
                  class: "social-post-page__textarea",
                  placeholder: "Write your post here...",
                  rows: "6"
                }, null, 512), [
                  [_vModelText, _ctx.form.caption]
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode(_component_el_popover, {
                    placement: "top",
                    width: 220,
                    trigger: "click"
                  }, {
                    reference: _withId(() => [
                      _createVNode("button", {
                        type: "button",
                        class: "social-post-page__tool-btn",
                        title: "Suggest caption",
                        disabled: !_ctx.hasGhlLocation
                      }, [
                        _hoisted_36
                      ], 8, ["disabled"])
                    ]),
                    default: _withId(() => [
                      _createVNode("div", _hoisted_37, [
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light text-start",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openSuggestCaption('draft')))
                        }, " Write a new caption "),
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light text-start",
                          disabled: !_ctx.form.caption.trim(),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openSuggestCaption('rewrite')))
                        }, " Rewrite what's in the box ", 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode("button", {
                    type: "button",
                    class: "social-post-page__tool-btn",
                    title: "Suggest post image",
                    disabled: !_ctx.hasGhlLocation,
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openSuggestPostImage && _ctx.openSuggestPostImage(...args)))
                  }, [
                    _hoisted_38
                  ], 8, ["disabled"]),
                  _createVNode("input", {
                    ref: "fileInput",
                    type: "file",
                    accept: "image/*,video/*",
                    multiple: "",
                    class: "d-none",
                    onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onFilesSelected && _ctx.onFilesSelected(...args)))
                  }, null, 544),
                  _createVNode("button", {
                    type: "button",
                    class: "social-post-page__tool-btn",
                    title: "Upload image or video",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.triggerFilePicker && _ctx.triggerFilePicker(...args)))
                  }, [
                    _hoisted_39
                  ]),
                  _createVNode(_component_el_popover, {
                    placement: "top",
                    width: 320,
                    trigger: "click"
                  }, {
                    reference: _withId(() => [
                      _hoisted_40
                    ]),
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _hoisted_41,
                        _withDirectives(_createVNode("textarea", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.mediaUrlsText = $event)),
                          class: "form-control form-control-sm mb-2",
                          rows: "4",
                          placeholder: "One URL per line"
                        }, null, 512), [
                          [_vModelText, _ctx.mediaUrlsText]
                        ]),
                        _hoisted_42
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_popover, {
                    placement: "top",
                    width: 280,
                    trigger: "click"
                  }, {
                    reference: _withId(() => [
                      _hoisted_43
                    ]),
                    default: _withId(() => [
                      _createVNode("div", null, [
                        _hoisted_44,
                        _withDirectives(_createVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.linkUrl = $event)),
                          type: "url",
                          class: "form-control form-control-sm",
                          placeholder: "https://..."
                        }, null, 512), [
                          [_vModelText, _ctx.form.linkUrl]
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode("div", _hoisted_45, [
                _createVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    width: 320
                  }, {
                    content: _withId(() => [
                      _hoisted_48
                    ]),
                    default: _withId(() => [
                      _hoisted_49
                    ]),
                    _: 1
                  })
                ]),
                _withDirectives(_createVNode("textarea", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.followUpComment = $event)),
                  class: "social-post-page__textarea social-post-page__textarea--compact",
                  placeholder: "Your first comment...",
                  rows: "3",
                  maxlength: _ctx.maxFollowUpCommentLength
                }, null, 8, ["maxlength"]), [
                  [_vModelText, _ctx.form.followUpComment]
                ]),
                _createVNode("div", _hoisted_50, _toDisplayString(_ctx.followUpCommentLength) + " / " + _toDisplayString(_ctx.maxFollowUpCommentLength) + " characters ", 1)
              ]),
              (_ctx.hasFacebookSelected)
                ? (_openBlock(), _createBlock("div", _hoisted_51, [
                    _createVNode("button", {
                      type: "button",
                      class: "social-post-page__section-toggle",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.facebookOptionsOpen = !_ctx.facebookOptionsOpen))
                    }, [
                      _hoisted_52,
                      _createVNode("i", {
                        class: _ctx.facebookOptionsOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
                      }, null, 2)
                    ]),
                    _withDirectives(_createVNode("div", _hoisted_53, [
                      _hoisted_54,
                      _createVNode("div", _hoisted_55, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.facebookPostTypeOptions, (option) => {
                          return (_openBlock(), _createBlock("label", {
                            key: option.value,
                            class: "social-post-page__radio-option"
                          }, [
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.facebookPostType = $event)),
                              type: "radio",
                              name: "facebookPostType",
                              value: option.value
                            }, null, 8, ["value"]), [
                              [_vModelRadio, _ctx.form.facebookPostType]
                            ]),
                            _createVNode("span", null, _toDisplayString(option.label), 1)
                          ]))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_56, _toDisplayString(_ctx.facebookPostTypeHelp), 1)
                    ], 512), [
                      [_vShow, _ctx.facebookOptionsOpen]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.facelessReelEnabled && _ctx.hasFacebookSelected && _ctx.form.facebookPostType === 'reel')
                ? (_openBlock(), _createBlock("div", _hoisted_57, [
                    _createVNode("button", {
                      type: "button",
                      class: "social-post-page__reel-panel-toggle mb-2",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.reelPanelExpanded = !_ctx.reelPanelExpanded))
                    }, [
                      _createVNode("div", _hoisted_58, [
                        _createVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _hoisted_61,
                          (!_ctx.reelPanelExpanded && _ctx.reelPanelCollapsedSummary)
                            ? (_openBlock(), _createBlock("span", _hoisted_62, " · " + _toDisplayString(_ctx.reelPanelCollapsedSummary), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_63
                      ]),
                      _createVNode("i", {
                        class: ["fas flex-shrink-0", _ctx.reelPanelExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
                      }, null, 2)
                    ]),
                    _withDirectives(_createVNode("div", _hoisted_64, [
                      _createVNode("div", _hoisted_65, _toDisplayString(_ctx.reelPanelIntro), 1),
                      _hoisted_66,
                      _createVNode("div", _hoisted_67, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reelTypeOptions, (option) => {
                          return (_openBlock(), _createBlock("label", {
                            key: option.id,
                            class: ["social-post-page__radio-option", { 'social-post-page__radio-option--disabled': !option.enabled }]
                          }, [
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.reelType = $event)),
                              type: "radio",
                              name: "reelType",
                              value: option.id,
                              disabled: !option.enabled || _ctx.reelScriptLoading || _ctx.reelGenerating
                            }, null, 8, ["value", "disabled"]), [
                              [_vModelRadio, _ctx.reelType]
                            ]),
                            _createVNode("span", null, _toDisplayString(option.label), 1),
                            (!option.enabled)
                              ? (_openBlock(), _createBlock("span", _hoisted_68, "Coming soon"))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ]),
                      _createVNode("div", _hoisted_69, _toDisplayString(_ctx.reelTypeHelp), 1),
                      (_ctx.reelType === 'business' || _ctx.reelType === 'ugc')
                        ? (_openBlock(), _createBlock(_component_ReelCatalogLibrary, {
                            key: 0,
                            modelValue: _ctx.reelCommunityMediaIds,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.reelCommunityMediaIds = $event))
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.reelType === 'ugc')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                            _hoisted_70,
                            _createVNode("div", _hoisted_71, [
                              _createVNode("label", _hoisted_72, [
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.reelUgcOverflow = $event)),
                                  type: "radio",
                                  name: "reelUgcOverflow",
                                  value: "freeze",
                                  disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                                }, null, 8, ["disabled"]), [
                                  [_vModelRadio, _ctx.reelUgcOverflow]
                                ]),
                                _hoisted_73
                              ]),
                              _createVNode("label", _hoisted_74, [
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.reelUgcOverflow = $event)),
                                  type: "radio",
                                  name: "reelUgcOverflow",
                                  value: "loop",
                                  disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                                }, null, 8, ["disabled"]), [
                                  [_vModelRadio, _ctx.reelUgcOverflow]
                                ]),
                                _hoisted_75
                              ])
                            ]),
                            _hoisted_76
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.reelType === 'product')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                            _hoisted_77,
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.reelProductSku,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.reelProductSku = $event)),
                              filterable: "",
                              clearable: "",
                              placeholder: "Pick a product from catalog",
                              class: "w-100 mb-3",
                              loading: _ctx.reelCatalogLoading,
                              disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reelCatalogProducts, (product) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: product.sku,
                                    label: `${product.name}`,
                                    value: product.sku
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "loading", "disabled"])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode("button", {
                        type: "button",
                        class: "social-post-page__reel-section-header mb-2",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.reelVoicesExpanded = !_ctx.reelVoicesExpanded))
                      }, [
                        _hoisted_78,
                        (!_ctx.reelVoicesExpanded)
                          ? (_openBlock(), _createBlock("span", _hoisted_79, " · " + _toDisplayString(_ctx.selectedReelVoiceLabel), 1))
                          : _createCommentVNode("", true),
                        _createVNode("i", {
                          class: ["fas ms-auto", _ctx.reelVoicesExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
                        }, null, 2)
                      ]),
                      _withDirectives(_createVNode(_component_ReelVoicePicker, {
                        voices: _ctx.reelVoices,
                        "model-value": _ctx.reelVoiceId,
                        expanded: _ctx.reelVoicesExpanded,
                        disabled: _ctx.reelScriptLoading || _ctx.reelGenerating,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.reelVoiceId = $event)),
                        onPreview: _ctx.playVoicePreview
                      }, null, 8, ["voices", "model-value", "expanded", "disabled", "onPreview"]), [
                        [_vShow, _ctx.reelVoicesExpanded]
                      ]),
                      _createVNode("button", {
                        type: "button",
                        class: "social-post-page__reel-section-header mb-2",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.reelTonesExpanded = !_ctx.reelTonesExpanded))
                      }, [
                        _hoisted_80,
                        (!_ctx.reelTonesExpanded)
                          ? (_openBlock(), _createBlock("span", _hoisted_81, " · " + _toDisplayString(_ctx.selectedReelToneLabel), 1))
                          : _createCommentVNode("", true),
                        _createVNode("i", {
                          class: ["fas ms-auto", _ctx.reelTonesExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
                        }, null, 2)
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_82, [
                        _hoisted_83,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reelTones, (tone) => {
                          return (_openBlock(), _createBlock("label", {
                            key: tone.id,
                            class: "social-post-page__reel-tone-option"
                          }, [
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.reelToneId = $event)),
                              type: "radio",
                              name: "reelTone",
                              value: tone.id,
                              disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                            }, null, 8, ["value", "disabled"]), [
                              [_vModelRadio, _ctx.reelToneId]
                            ]),
                            _createVNode("span", _hoisted_84, [
                              _createVNode("span", _hoisted_85, [
                                _createVNode("span", null, _toDisplayString(tone.label), 1),
                                _createVNode("button", {
                                  type: "button",
                                  class: "btn btn-link btn-sm p-0 ms-2 align-baseline",
                                  disabled: !_ctx.reelVoices.length,
                                  onClick: _withModifiers(($event: any) => (_ctx.playVoicePreview(null, tone.id)), ["stop","prevent"])
                                }, " Preview ", 8, ["disabled", "onClick"])
                              ]),
                              (tone.description)
                                ? (_openBlock(), _createBlock("span", _hoisted_86, _toDisplayString(tone.description), 1))
                                : _createCommentVNode("", true),
                              (tone.bestFor)
                                ? (_openBlock(), _createBlock("span", _hoisted_87, " Best for: " + _toDisplayString(tone.bestFor), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _ctx.reelTonesExpanded]
                      ]),
                      (_ctx.hasReelMusicCatalog)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                            _createVNode("button", {
                              type: "button",
                              class: "social-post-page__reel-section-header mb-2",
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.reelMusicExpanded = !_ctx.reelMusicExpanded))
                            }, [
                              _hoisted_88,
                              (!_ctx.reelMusicExpanded)
                                ? (_openBlock(), _createBlock("span", _hoisted_89, " · " + _toDisplayString(_ctx.selectedReelMusicLabel), 1))
                                : _createCommentVNode("", true),
                              _createVNode("i", {
                                class: ["fas ms-auto", _ctx.reelMusicExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
                              }, null, 2)
                            ]),
                            _withDirectives(_createVNode("div", _hoisted_90, [
                              _hoisted_91,
                              _createVNode("label", _hoisted_92, [
                                _withDirectives(_createVNode("input", {
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.reelMusicTrackId = $event)),
                                  type: "radio",
                                  name: "reelMusic",
                                  value: null,
                                  disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                                }, null, 8, ["disabled"]), [
                                  [_vModelRadio, _ctx.reelMusicTrackId]
                                ]),
                                _hoisted_93
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reelMusicTracks, (track) => {
                                return (_openBlock(), _createBlock("label", {
                                  key: track.id,
                                  class: "social-post-page__reel-tone-option"
                                }, [
                                  _withDirectives(_createVNode("input", {
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.reelMusicTrackId = $event)),
                                    type: "radio",
                                    name: "reelMusic",
                                    value: track.id,
                                    disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                                  }, null, 8, ["value", "disabled"]), [
                                    [_vModelRadio, _ctx.reelMusicTrackId]
                                  ]),
                                  _createVNode("span", _hoisted_94, [
                                    _createVNode("span", _hoisted_95, [
                                      _createTextVNode(_toDisplayString(track.title) + " ", 1),
                                      (track.durationSec)
                                        ? (_openBlock(), _createBlock("span", _hoisted_96, " · " + _toDisplayString(_ctx.formatReelMusicDuration(track.durationSec)), 1))
                                        : _createCommentVNode("", true),
                                      (track.previewUrl)
                                        ? (_openBlock(), _createBlock("button", {
                                            key: 1,
                                            type: "button",
                                            class: "btn btn-link btn-sm p-0 ms-2 align-baseline",
                                            onClick: _withModifiers(($event: any) => (_ctx.playMusicPreview(track)), ["stop","prevent"])
                                          }, " Preview ", 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (track.licenseName || _ctx.reelMusicLicenseHref(track))
                                      ? (_openBlock(), _createBlock("span", _hoisted_97, [
                                          _createTextVNode(_toDisplayString(track.licenseName || "License") + " ", 1),
                                          (_ctx.reelMusicLicenseHref(track))
                                            ? (_openBlock(), _createBlock("a", {
                                                key: 0,
                                                href: _ctx.reelMusicLicenseHref(track),
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                class: "ms-1",
                                                onClick: _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"]))
                                              }, "View license", 8, ["href"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ], 512), [
                              [_vShow, _ctx.reelMusicExpanded]
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode("button", {
                        type: "button",
                        class: "social-post-page__reel-section-header mb-2",
                        onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.reelCaptionStyleExpanded = !_ctx.reelCaptionStyleExpanded))
                      }, [
                        _hoisted_98,
                        (!_ctx.reelCaptionStyleExpanded)
                          ? (_openBlock(), _createBlock("span", _hoisted_99, " · " + _toDisplayString(_ctx.selectedReelCaptionStyleLabel), 1))
                          : _createCommentVNode("", true),
                        _createVNode("i", {
                          class: ["fas ms-auto", _ctx.reelCaptionStyleExpanded ? 'fa-chevron-up' : 'fa-chevron-down']
                        }, null, 2)
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _createVNode("div", _hoisted_102, [
                          _createVNode("span", {
                            class: ["social-post-page__caption-preview-text", _ctx.captionStylePreviewClasses]
                          }, _toDisplayString(_ctx.captionStylePreviewText), 3)
                        ]),
                        _createVNode("div", _hoisted_103, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.captionPresets, (preset) => {
                            return (_openBlock(), _createBlock("label", {
                              key: preset.id,
                              class: "social-post-page__caption-swatch-option",
                              title: preset.label
                            }, [
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": ($event: any) => (_ctx.reelCaptionStyle.preset = $event),
                                type: "radio",
                                name: "reelCaptionPreset",
                                value: preset.id,
                                disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                              }, null, 8, ["onUpdate:modelValue", "value", "disabled"]), [
                                [_vModelRadio, _ctx.reelCaptionStyle.preset]
                              ]),
                              _createVNode("span", {
                                class: ["social-post-page__caption-swatch", preset.swatchClass]
                              }, [
                                _hoisted_104
                              ], 2),
                              _createVNode("span", _hoisted_105, _toDisplayString(preset.label), 1)
                            ], 8, ["title"]))
                          }), 128))
                        ]),
                        _hoisted_106,
                        _createVNode("div", _hoisted_107, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.captionSizeOptions, (option) => {
                            return (_openBlock(), _createBlock("label", {
                              key: option.id,
                              class: "social-post-page__radio-option"
                            }, [
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.reelCaptionStyle.size = $event)),
                                type: "radio",
                                name: "reelCaptionSize",
                                value: option.id,
                                disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                              }, null, 8, ["value", "disabled"]), [
                                [_vModelRadio, _ctx.reelCaptionStyle.size]
                              ]),
                              _createVNode("span", null, _toDisplayString(option.label), 1)
                            ]))
                          }), 128))
                        ]),
                        _hoisted_108,
                        _createVNode("div", _hoisted_109, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.captionPositionOptions, (option) => {
                            return (_openBlock(), _createBlock("label", {
                              key: option.id,
                              class: "social-post-page__radio-option"
                            }, [
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.reelCaptionStyle.position = $event)),
                                type: "radio",
                                name: "reelCaptionPosition",
                                value: option.id,
                                disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                              }, null, 8, ["value", "disabled"]), [
                                [_vModelRadio, _ctx.reelCaptionStyle.position]
                              ]),
                              _createVNode("span", null, _toDisplayString(option.label), 1)
                            ]))
                          }), 128))
                        ]),
                        _hoisted_110,
                        _createVNode("div", _hoisted_111, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.captionCasingOptions, (option) => {
                            return (_openBlock(), _createBlock("label", {
                              key: option.id,
                              class: "social-post-page__radio-option"
                            }, [
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.reelCaptionStyle.casing = $event)),
                                type: "radio",
                                name: "reelCaptionCasing",
                                value: option.id,
                                disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                              }, null, 8, ["value", "disabled"]), [
                                [_vModelRadio, _ctx.reelCaptionStyle.casing]
                              ]),
                              _createVNode("span", null, _toDisplayString(option.label), 1)
                            ]))
                          }), 128))
                        ])
                      ], 512), [
                        [_vShow, _ctx.reelCaptionStyleExpanded]
                      ]),
                      _createVNode("label", _hoisted_112, [
                        _hoisted_113,
                        (_ctx.reelType === 'business' || _ctx.reelType === 'ugc')
                          ? (_openBlock(), _createBlock("span", _hoisted_114, " (required)"))
                          : (_openBlock(), _createBlock("span", _hoisted_115, " (optional)"))
                      ]),
                      _withDirectives(_createVNode("textarea", {
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.reelBrief = $event)),
                        class: "form-control mb-2",
                        rows: "3",
                        placeholder: _ctx.reelBriefPlaceholder,
                        disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                      }, null, 8, ["placeholder", "disabled"]), [
                        [_vModelText, _ctx.reelBrief]
                      ]),
                      _createVNode("div", _hoisted_116, _toDisplayString(_ctx.reelBriefHelp), 1),
                      _hoisted_117,
                      _withDirectives(_createVNode("textarea", {
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.reelVoiceover = $event)),
                        class: "form-control mb-3",
                        rows: "5",
                        placeholder: "Generate a script or write your own voiceover…",
                        disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                      }, null, 8, ["disabled"]), [
                        [_vModelText, _ctx.reelVoiceover]
                      ]),
                      (_ctx.reelScenes.length)
                        ? (_openBlock(), _createBlock(_component_ReelSceneEditor, {
                            key: 4,
                            modelValue: _ctx.reelScenes,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.reelScenes = $event)),
                            "reel-type": _ctx.reelType,
                            disabled: _ctx.reelScriptLoading || _ctx.reelGenerating
                          }, null, 8, ["modelValue", "reel-type", "disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_118, [
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-light btn-sm",
                          disabled: _ctx.reelScriptGenerateDisabled,
                          onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.generateReelScript && _ctx.generateReelScript(...args)))
                        }, _toDisplayString(_ctx.reelScriptLoading ? "Generating script…" : "Generate script"), 9, ["disabled"]),
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-primary btn-sm",
                          disabled: _ctx.reelGenerateDisabled,
                          onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.generateReelVideo && _ctx.generateReelVideo(...args)))
                        }, _toDisplayString(_ctx.reelGenerating ? "Generating video…" : _ctx.reelGenerateButtonLabel), 9, ["disabled"])
                      ]),
                      (_ctx.reelJobError)
                        ? (_openBlock(), _createBlock("div", _hoisted_119, _toDisplayString(_ctx.reelJobError), 1))
                        : _createCommentVNode("", true),
                      (_ctx.reelJobMusic?.title)
                        ? (_openBlock(), _createBlock("div", _hoisted_120, [
                            _hoisted_121,
                            (_ctx.reelJobMusic.sourcePageUrl)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: _ctx.reelJobMusic.sourcePageUrl,
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, _toDisplayString(_ctx.reelJobMusic.title), 9, ["href"]))
                              : (_openBlock(), _createBlock("span", _hoisted_122, _toDisplayString(_ctx.reelJobMusic.title), 1)),
                            (_ctx.reelJobMusic.licenseName)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(" · " + _toDisplayString(_ctx.reelJobMusic.licenseName), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.reelMusicLicenseHref(_ctx.reelJobMusic))
                              ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                                  _hoisted_123,
                                  _createVNode("a", {
                                    href: _ctx.reelMusicLicenseHref(_ctx.reelJobMusic),
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                  }, "View license", 8, ["href"])
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ], 512), [
                      [_vShow, _ctx.reelPanelExpanded]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pendingFiles.length || _ctx.attachedPreviewUrls.length)
                ? (_openBlock(), _createBlock("div", _hoisted_124, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pendingFiles, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: `pending-${index}`,
                        class: "social-post-page__attachment"
                      }, [
                        (item.previewUrl && item.isImage)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: item.previewUrl,
                              alt: ""
                            }, null, 8, ["src"]))
                          : (item.previewUrl)
                            ? (_openBlock(), _createBlock("video", {
                                key: 1,
                                class: "social-post-page__attachment-player",
                                src: item.previewUrl,
                                muted: "",
                                playsinline: "",
                                preload: "metadata"
                              }, null, 8, ["src"]))
                            : (_openBlock(), _createBlock("div", _hoisted_125, [
                                _hoisted_126
                              ])),
                        _createVNode("button", {
                          type: "button",
                          class: "social-post-page__attachment-remove",
                          onClick: ($event: any) => (_ctx.removePendingFile(index))
                        }, [
                          _hoisted_127
                        ], 8, ["onClick"]),
                        _hoisted_128
                      ]))
                    }), 128)),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attachedPreviewUrls, (url) => {
                      return (_openBlock(), _createBlock("div", {
                        key: url,
                        class: "social-post-page__attachment"
                      }, [
                        (_ctx.isPreviewImage(url))
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: url,
                              alt: ""
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock("video", {
                              key: 1,
                              class: "social-post-page__attachment-player",
                              src: url,
                              muted: "",
                              playsinline: "",
                              preload: "metadata"
                            }, null, 8, ["src"]))
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ContentMediaLibrary, {
                ref: "mediaLibrary",
                "selected-ids": _ctx.attachedMediaIds,
                "onUpdate:selected-ids": _cache[39] || (_cache[39] = ($event: any) => (_ctx.attachedMediaIds = $event)),
                "single-video": _ctx.requiresSingleVideo,
                onRefresh: _ctx.onMediaLibraryRefresh
              }, null, 8, ["selected-ids", "single-video", "onRefresh"]),
              (_ctx.isTeamLeader)
                ? (_openBlock(), _createBlock("div", _hoisted_129, [
                    _createVNode("div", _hoisted_130, [
                      _withDirectives(_createVNode("input", {
                        id: "cascadeToTeam",
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.form.cascadeToTeam = $event)),
                        class: "form-check-input",
                        type: "checkbox"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.cascadeToTeam]
                      ]),
                      _hoisted_131
                    ]),
                    (_ctx.form.cascadeToTeam)
                      ? (_openBlock(), _createBlock("div", _hoisted_132, [
                          _hoisted_133,
                          _createVNode("div", _hoisted_134, [
                            _withDirectives(_createVNode("input", {
                              id: "varyCaption",
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.form.varyCaption = $event)),
                              class: "form-check-input",
                              type: "checkbox"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.form.varyCaption]
                            ]),
                            _hoisted_135
                          ]),
                          (_ctx.form.varyCaption)
                            ? (_openBlock(), _createBlock("div", _hoisted_136, " Uses AI tokens (charged to you, once per team member). "))
                            : _createCommentVNode("", true),
                          _hoisted_137
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_138, " Team members must have opted in via Social Fan-out settings. "))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_139, [
              _createVNode("div", _hoisted_140, [
                (_ctx.canDiscardDraft)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-light-danger",
                      disabled: _ctx.footerDisabled || _ctx.discarding,
                      onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.discardDraft && _ctx.discardDraft(...args)))
                    }, _toDisplayString(_ctx.discarding ? "Discarding..." : "Discard"), 9, ["disabled"]))
                  : _createCommentVNode("", true),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  disabled: _ctx.footerDisabled,
                  onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args)))
                }, _toDisplayString(_ctx.saving ? "Saving..." : "Save for later"), 9, ["disabled"])
              ]),
              _createVNode("div", _hoisted_141, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary social-post-page__post-btn",
                  disabled: _ctx.postDisabled,
                  onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.submitPostNow && _ctx.submitPostNow(...args)))
                }, [
                  _hoisted_142,
                  _createTextVNode(" " + _toDisplayString(_ctx.publishing ? "Posting..." : _ctx.postButtonLabel), 1)
                ], 8, ["disabled"]),
                _createVNode(_component_el_dropdown, {
                  trigger: "click",
                  onCommand: _ctx.handlePostMenu
                }, {
                  dropdown: _withId(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_dropdown_item, { command: "now" }, {
                          default: _withId(() => [
                            _hoisted_144
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { command: "schedule" }, {
                          default: _withId(() => [
                            _hoisted_145
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withId(() => [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-primary social-post-page__post-menu",
                      disabled: _ctx.postDisabled
                    }, [
                      _hoisted_143
                    ], 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["onCommand"])
              ], 512)
            ])
          ]),
          (_ctx.lastResult)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: ["alert mt-4 mb-0", _ctx.lastResult.status === 'rejected' ? 'alert-danger' : 'alert-info']
              }, [
                (_ctx.lastResult.status === 'preparing')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " is preparing media uploads. ", 1)
                    ], 64))
                  : (_ctx.lastResult.status === 'draft')
                    ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Draft saved as campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + ". ", 1)
                      ], 64))
                    : (_ctx.lastResult.status === 'rejected')
                      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " was blocked by AI review: " + _toDisplayString(_ctx.lastResult.moderationSummary || 'Post violates company rules.'), 1)
                        ], 64))
                      : (_ctx.lastResult.status === 'pending_review')
                        ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " is under AI review before team fan-out. ", 1)
                          ], 64))
                        : (_ctx.lastResult.status === 'awaiting_original')
                          ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                              _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " — your post is live. Team link posts will be scheduled after the original is confirmed. ", 1)
                            ], 64))
                          : (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                              _createTextVNode(" Campaign #" + _toDisplayString(_ctx.lastResult.campaignId) + " — posted " + _toDisplayString(_ctx.lastResult.postedCount) + ", skipped " + _toDisplayString(_ctx.lastResult.skippedCount) + ", failed " + _toDisplayString(_ctx.lastResult.failedCount), 1)
                            ], 64))
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_146, [
          _createVNode(_component_SocialPostPreview, {
            "selected-accounts": _ctx.selectedAccounts,
            caption: _ctx.form.caption,
            "media-urls": _ctx.previewMediaUrls,
            "media-items": _ctx.previewMediaItems,
            "link-url": _ctx.form.linkUrl,
            "follow-up-comment": _ctx.form.followUpComment,
            "facebook-post-type": _ctx.form.facebookPostType
          }, null, 8, ["selected-accounts", "caption", "media-urls", "media-items", "link-url", "follow-up-comment", "facebook-post-type"])
        ])
      ]),
      _createVNode(_component_SuggestCaptionDialog, {
        modelValue: _ctx.suggestCaptionVisible,
        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (_ctx.suggestCaptionVisible = $event)),
        mode: _ctx.suggestCaptionMode,
        platforms: _ctx.form.platforms,
        "existing-caption": _ctx.form.caption,
        onSelect: _ctx.applySuggestedCaption
      }, null, 8, ["modelValue", "mode", "platforms", "existing-caption", "onSelect"]),
      _createVNode(_component_SuggestPostImageDialog, {
        modelValue: _ctx.suggestPostImageVisible,
        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.suggestPostImageVisible = $event)),
        platforms: _ctx.form.platforms,
        "initial-prompt": _ctx.form.caption,
        onSelect: _ctx.applySuggestedImage
      }, null, 8, ["modelValue", "platforms", "initial-prompt", "onSelect"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.scheduleDialogVisible,
        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (_ctx.scheduleDialogVisible = $event)),
        title: "Schedule post",
        width: "360px"
      }, {
        footer: _withId(() => [
          _createVNode("button", {
            type: "button",
            class: "btn btn-light",
            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.scheduleDialogVisible = false))
          }, " Cancel "),
          _createVNode("button", {
            type: "button",
            class: "btn btn-primary ms-2",
            disabled: !_ctx.form.scheduledAt || _ctx.publishing,
            onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.submitScheduledPost && _ctx.submitScheduledPost(...args)))
          }, " Schedule ", 8, ["disabled"])
        ]),
        default: _withId(() => [
          _hoisted_147,
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_ctx.form.scheduledAt = $event)),
            type: "datetime-local",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.form.scheduledAt]
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 512), [
      [_vShow, !_ctx.loading]
    ])
  ]))
})